/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const EditorWrapper = styled.div`
  height: 100%;

  .cm-content {
    height: 100%;
    font-family: 'IBM Plex Mono', monospace;
    font-size: 14px;
  }

  .cm-scroller {
    padding: 'var(--cds-spacing-01)';
  }

  .cm-placeholder {
    color: 'var(--cds-text-placeholder)';
  }

  .cm-editor {
    height: 100%;
  }

  .ͼ1.cm-focused {
    outline: none;
  }
`;
